import { NBN_UPDATE_TEST_RESULT, NBN_UPDATE_DIAGNOSTIC_RESULT, NBN_ADD_TOAST, NBN_DELETE_TOAST,
    NBN_ADD_RESULT_TOAST, NBN_DELETE_RESULT_TOAST, NBN_DISMISS_RESULT_TOAST,
    NBN_ADD_ERROR_TOAST, NBN_DELETE_ERROR_TOAST, NBN_UPDATE_DIAGNOSTIC_ERROR,
    NBN_UPDATE_RESULT } from './action-types';
import { INBNTestCreate } from '../state/create-nbn-test'
import { INBNTestData } from '../state/nbn-test-results';

export interface IUpdateNbnTestResultAction {
    type: string;
    data: INBNTestCreate;
}

interface IServices {
    serviceId?: string;
    diagnosticResult?: string;
    diagnosticResultMessage?: string;
}
export interface IUpdateNbnTestErrorAction {
    type: string;
    services: IServices[];
    status: string;
    result: string;
}

export interface IUpdateDiagnosticResultAction {
    type: string;
    data: INBNTestCreate;
    diagnosticName: string;
}
export interface IAddToastAction {
    type: string,
    test: INBNTestCreate
}

export interface IAddResultToastAction {
    type: string,
    result: INBNTestData
}

export interface IAddErrorToastAction {
    type: string,
    status: string,
    services: IServices[],
    diagnosticName: string
}

export interface IDeleteErrorToastAction {
    type: string,
    status: string,
    services: IServices[],
    diagnosticName: string
}
export interface IDismissResultToastAction {
    type: string,
    serviceId: string,
    diagnosticResult: string
}

export const updateNbnTestMessage = (data: INBNTestCreate): IUpdateNbnTestResultAction => ({
    type: NBN_UPDATE_TEST_RESULT,
    data
});

export const updateNbnErrorMessage = (services: IServices[], status: string, result: string): IUpdateNbnTestErrorAction => ({
    type: NBN_UPDATE_DIAGNOSTIC_ERROR,
    services,
    status,
    result
});

export const updateNbnResultMessage = (data: INBNTestCreate
): IUpdateNbnTestResultAction => ({
    type: NBN_UPDATE_RESULT,
    data
});

export const updateDiagnosticResult = (data: INBNTestData, diagnosticName: string):
IUpdateDiagnosticResultAction => ({
    type: NBN_UPDATE_DIAGNOSTIC_RESULT,
    data,
    diagnosticName
});

export const addToast = (test: INBNTestCreate): IAddToastAction => ({
    type: NBN_ADD_TOAST,
    test
});

export const deleteToast = (test: INBNTestCreate):
IAddToastAction => ({
    type: NBN_DELETE_TOAST,
    test
});

export const addResultToast = (result: INBNTestData): IAddResultToastAction => ({
    type: NBN_ADD_RESULT_TOAST,
    result
});

export const deleteResultToast = (result: INBNTestData):
IAddResultToastAction => ({
    type: NBN_DELETE_RESULT_TOAST,
    result
});

export const dismissResultToast = (serviceId: string, diagnosticResult: string):
IDismissResultToastAction => ({
    type: NBN_DISMISS_RESULT_TOAST,
    serviceId,
    diagnosticResult
});

export const addErrorToast = (services: IServices[], diagnosticName: string, status: string): IAddErrorToastAction => ({
    type: NBN_ADD_ERROR_TOAST,
    status,
    diagnosticName,
    services
});

export const deleteErrorToast = (services: IServices[], diagnosticName: string, status: string):
IDeleteErrorToastAction => ({
    type: NBN_DELETE_ERROR_TOAST,
    status,
    diagnosticName,
    services
});
